import { Component, computed, inject, viewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CookieComponent } from './components/cookie/cookie.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { RestaurantConfigService } from './services/restaurant-config.service';

@Component({
  selector: 'app-root',
  imports: [NavbarComponent, RouterOutlet, FooterComponent, CookieComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly restaurantConfig = inject(RestaurantConfigService);

  private readonly cookie = viewChild(CookieComponent);
  readonly cookieBannerOpen = computed(() => this.cookie()?.isVisible() ?? false);

  readonly layoutTheme = computed(() => this.restaurantConfig.config().theme);
}
